import React from 'react';
import { useNavigate } from 'react-router-dom';
import { products, platformInfo, ProductCta } from '../../config/landingData';
import { route } from '../../config/paths';
import './ProductsSection.css';

const ProductsSection: React.FC = () => {
  const navigate = useNavigate();

  const handleCta = (cta: ProductCta) => {
    if (cta.type === 'route') {
      navigate(route(cta.path));
      return;
    }
    const el = document.querySelector(cta.href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.hash = cta.href;
    }
  };

  return (
    <section id="products" className="products-section">
      <div className="products-container">
        <div className="products-header">
          <h2 className="products-title">Three products. One conversation stack.</h2>
          <p className="products-subtitle">
            AutoQA, AgentAssist, and Voice Agent — equal building blocks to evaluate, coach, and act.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <article
              key={product.id}
              id={product.id}
              className="product-card"
              style={{ ['--product-accent' as string]: product.accent }}
            >
              <div className="product-card-top">
                <div className="product-icon-wrap" style={{ color: product.accent }}>
                  {product.icon}
                </div>
                <p className="product-tagline">{product.tagline}</p>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
              </div>

              <ul className="product-highlights">
                {product.highlights.map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>

              <div className="product-actions">
                <button
                  type="button"
                  className="product-cta-primary"
                  onClick={() => handleCta(product.primaryCta)}
                >
                  {product.primaryCta.label}
                </button>
                <button
                  type="button"
                  className="product-cta-secondary"
                  onClick={() => handleCta(product.secondaryCta)}
                >
                  {product.secondaryCta.label}
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="platform-arc">
          <p className="platform-arc-label">{platformInfo.platformArc.label}</p>
          <p className="platform-arc-description">{platformInfo.platformArc.description}</p>
          <div className="platform-arc-steps">
            {platformInfo.pillars.map((pillar) => (
              <div key={pillar.title} className="platform-arc-step">
                <div className="platform-arc-icon">{pillar.icon}</div>
                <h4>{pillar.title}</h4>
                <p>{pillar.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
